// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/icon/iconfont.css'
import 'vue-area-linkage/dist/index.css';
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import vueQuillEditor from 'vue-quill-editor' // 引入富文本工具
import VueAreaLinkage from 'vue-area-linkage';
import store from './vuexStore'


Vue.use(Element)
Vue.use(VueAreaLinkage)
Vue.config.productionTip = false
Vue.use(vueQuillEditor)
/* eslint-disable no-new */
router.beforeEach((to, from, next) => {
  if (to.path.startsWith('/login')) {
    window.localStorage.removeItem('access-user')
    next()
  } else {
    if (to.path.indexOf('_list') != -1 && to.path != '/sign_list') {
      store.commit('jumpTo', to.path)
    }

    let user = window.localStorage.getItem('api_token')
    if (!user) {
      next({
        path: '/login'
      })
    } else {
      next()
    }
    //add_good,editNormalUser, addNormalUser, editUpRule, downRoleType addOrEditSendActivity addCourse
    if (to.path.startsWith('/addBanner') || to.path.startsWith('/addCourse') || to.path.startsWith('/addOrEditSendActivity') || to.path.startsWith('/editUpLog') || to.path.startsWith('/downRoleType') || to.path.startsWith('/checkRecord') || to.path.startsWith('/add_activityManagement') || to.path.startsWith('/add_good') || to.path.startsWith('/editNormalUser') || to.path.startsWith('/addNormalUser') || to.path.startsWith('/companySet') || to.path.startsWith('/editUpRule') || to.path.startsWith('/score_detail'))
    {
      return;
    } else {
      store.dispatch('worktabRoute', {
        to: {
          name: to.name ? to.name : '',
          tabname: (to.meta && to.meta.tabname) ? to.meta.tabname : '',
          path: to.path
        },
        from: {
          name: from.name ? from.name : '',
          tabname: (from.meta && from.meta.tabname) ? from.meta.tabname : '',
          path: from.path
        }
      })
    }

    return
  }
})

new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js